import { render, staticRenderFns } from "./ProjectSettingsPermission.vue?vue&type=template&id=5032a3f4&scoped=true"
import script from "./ProjectSettingsPermission.vue?vue&type=script&lang=js"
export * from "./ProjectSettingsPermission.vue?vue&type=script&lang=js"
import style0 from "./ProjectSettingsPermission.vue?vue&type=style&index=0&id=5032a3f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5032a3f4",
  null
  
)

export default component.exports